import { render } from "./AppDisconnected.vue?vue&type=template&id=605c6956"
import script from "./AppDisconnected.vue?vue&type=script&lang=js"
export * from "./AppDisconnected.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__